// extracted by mini-css-extract-plugin
module.exports = {"translationForm":"_30TosnNXc1oYZ39n03orST"};